import React from 'react';
import { connect } from 'react-redux';
// import { Route, Switch, Prompt, } from 'react-router';
import { BrowserRouter as Router, Switch, Route, Prompt } from 'react-router-dom';
import Layout from './components/layout/Layout';
// import AppUpdate from './AppUpdate';
import Loadable from 'jaybe-react-loadable';
import { LoaderTwo } from './components/loading/Loader';
import { getUser, updateUserDataDarkMode, } from './_global/_helpers';
import { userActions, alertActions } from './_global/_actions';
import { CircularProgress } from '@material-ui/core';
import { url } from './store';
import { latestVersion } from './page/Version';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: { main: '#1e88e5', },
    // secondary: pink,
  },
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true
  },
});

const themeDark = createMuiTheme({
  palette: {
    type: 'dark',
    primary: { main: '#1e88e5', },
    // secondary: pink,
  },
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true
  },
});

//#region Import
const Loading = () => <div className="loading">
  <CircularProgress size={50} />
</div>;

const PageNotUpdate = Loadable({
  loader: () => import('./page/PageNotUpdate'),
  loading: Loading,
});

const Page404 = Loadable({
  loader: () => import('./page/Page404'),
  loading: Loading,
});

const Home = Loadable({
  loader: () => import('./page/Home'),
  loading: Loading,
});

const LandingPage = Loadable({
  loader: () => import('./page/LandingPage'),
  loading: Loading,
});

const Signin = Loadable({
  loader: () => import('./page/SignIn'),
  loading: Loading,
});

const ResetPassword = Loadable({
  loader: () => import('./page/ResetPassword'),
  loading: Loading,
});

const AccountSetup = Loadable({
  loader: () => import('./page/AccountSetup'),
  loading: Loading,
});

const MyAccount = Loadable({
  loader: () => import('./page/MyAccount'),
  loading: Loading,
});

const MyAccountUpdate = Loadable({
  loader: () => import('./page/MyAccountEdit'),
  loading: Loading,
});

const HelpSupport = Loadable({
  loader: () => import('./page/HelpSupport'),
  loading: Loading,
});

const Version = Loadable({
  loader: () => import('./page/Version'),
  loading: Loading,
});

const SystemAccount = Loadable({
  loader: () => import('./page/SystemAccount'),
  loading: Loading,
});

const MasterData = Loadable({
  loader: () => import('./page/MasterData'),
  loading: Loading,
});

const SalesQuotation = Loadable({
  loader: () => import('./page/SalesQuotation'),
  loading: Loading,
});

const Voyage = Loadable({
  loader: () => import('./page/Voyage'),
  loading: Loading,
});

const Outbound = Loadable({
  loader: () => import('./page/Outbound'),
  loading: Loading,
});

const Inbound = Loadable({
  loader: () => import('./page/Inbound'),
  loading: Loading
});

const BookingLink2 = Loadable({
  loader: () => import('./components/booking/BookingLink2'),
  loading: Loading
});

const BookingSuccess = Loadable({
  loader: () => import('./components/booking/BookingSuccess'),
  loading: Loading
});

const AuthorizationLetter = Loadable({
  loader: () => import('./components/booking/AuthorizationLetter'),
  loading: Loading
});

const PickUpRequest = Loadable({
  loader: () => import('./components/booking/PickUpRequest'),
  loading: Loading
});

const loadingConfirmation = Loadable({
  loader: () => import('./components/booking/BoookingLoadingConfirmation'),
  loading: Loading
});

const BookingChanges = Loadable({
  loader: () => import('./page/BookingChanges'),
  loading: Loading
});

const Notification = Loadable({
  loader: () => import('./page/Notification'),
  loading: Loading
});

const Calendar = Loadable({
  loader: () => import('./page/Calendar'),
  loading: Loading
});

const Waiver = Loadable({
  loader: () => import('./page/Waiver'),
  loading: Loading
});

const CROAccounting = Loadable({
  loader: () => import('./page/CROAccounting'),
  loading: Loading
});

const Hustling = Loadable({
  loader: () => import('./page/Hustling'),
  loading: Loading
});

const CustomerRequest = Loadable({
  loader: () => import('./page/customerRequest'),
  loading: Loading
});

const OverrideCharge = Loadable({
  loader: () => import('./page/OverrideCharge'),
  loading: Loading
});

const ShipmentTracking = Loadable({
  loader: () => import('./page/CustomerShipmentTracking'),
  loading: Loading
});

// const SQUpdate = Loadable({
//   loader: () => import('./page/SQUpdate'),
//   loading: Loading,
// });
//#endregion

class App extends React.Component {
  state = {
    isLoading: true,
    user: null,
    seconds: 0,
    currentVersion: "",
  }

  componentDidMount() {
    // document.addEventListener('contextmenu', (e) => {
    //   e.preventDefault();
    // });
    // window.addEventListener("auxclick", (event) => {
    //   if (event.button === 1) event.preventDefault();
    // });
    // document.cookie = `HttpOnly;Secure;SameSite=Strict`;
    getUser().then((user) => {
      this.setState({ user: user });
      if(user){
        this.props.dispatch(userActions.getUserByIdLogin(user.userId));
      }
      else {
        setTimeout(() => this.setState({ isLoading: false }), 3000);
      }
    });
    // this.interval = setInterval(() => this.tick(), 1000);

    if(url === "https://oouidev.azurewebsites.net"){
      this.props.dispatch(userActions.getCurrentVersion("HBS"));
    }
    else {
      this.props.dispatch(userActions.getCurrentVersion("AUSS_ADMIN"));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.currentVersion && nextProps.currentVersion !== this.props.currentVersion){
      // console.log('nextProps.currentVersion', nextProps.currentVersion);
      this.setState({ currentVersion: nextProps.currentVersion })
    }
    if(this.state.isLoading && this.state.user && nextProps.userlogin && nextProps.userlogin.length > 0 && nextProps.userlogin !== this.props.userlogin){
      let user = this.state.user;
      let userlogin = nextProps.userlogin[0];
      
      let devicelogin = user.devicelogin;
      if(devicelogin){
        let df = new Date(devicelogin);
        let dftime = df.getTime();
        let dt = new Date(userlogin.dateModified);
        let dttime = dt.getTime();
        if(dttime > dftime){
          this.props.dispatch(alertActions.info("User Changes: Please Login Again", 2000));
          setTimeout(() => {
            this.props.dispatch(userActions.logout(user.id, user.userId));            
          }, 3000);
        }
      }
      else {
        this.props.dispatch(alertActions.info("User Changes: Please Login Again", 2000));
        setTimeout(() => {
          this.props.dispatch(userActions.logout(user.id, user.userId));            
        }, 3000);
      }
      setTimeout(() => this.setState({ isLoading: false }), 3000);
    }
  }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  // tick() {
  //   this.setState(state => ({
  //     seconds: state.seconds + 1
  //   }));
  // }

  // tickReset = () => {
  //   this.setState({ seconds: 0 })
  // }

  // userIdle = () => {
  //   this.props.dispatch(userActions.logout(this.state.user.id, this.state.user.userId));
  // }

  toggleTheme = (e) => {
    let { user } = this.state;
    const { checked } = e.target;
    user.darkMode = checked
    this.setState({ user }, () => {
      updateUserDataDarkMode(user.id, checked);
    });
  }
  
  render() {
    let { allowLeavePage } = this.props;
    // console.log('allowLeavePage', allowLeavePage);
    // console.log(this.state.seconds)
    // if(this.state.seconds === 3600 && this.state.user){
    //   this.userIdle();
    // }
    return (<ThemeProvider theme={this.state.user && this.state.user.darkMode ? themeDark : theme}>
    <Router basename="/">
      {this.state.isLoading ? <LoaderTwo /> :
        (
          <div 
            // onMouseDown={this.handleMouseDown}
            // onTouchMove={() => this.tickReset()} onMouseMove={() => this.tickReset()} onKeyPress={() => this.tickReset()}
            >
            {allowLeavePage === true || allowLeavePage === false ? <Prompt when={allowLeavePage} message='You have still process data, are you sure you want to leave?' /> : null}
            {
              this.state.user ? (
                <Layout toggleTheme={this.toggleTheme} user={this.state.user} path={window.location.pathname}>
                  {
                    this.state.currentVersion && this.state.currentVersion !== "" && this.state.currentVersion !== latestVersion ?
                      <React.Fragment>
                        <Switch>
                          <Route render={() => <PageNotUpdate currentVersion={this.state.currentVersion} yourVersion={latestVersion} />} />
                        </Switch>
                      </React.Fragment>
                      : <React.Fragment>
                      <Switch>
                        <Route exact path='/' component={Home} />
                        <Route exact path='/myAccount' component={MyAccount} />
                        <Route exact path='/myAccount/edit/:id' component={MyAccountUpdate} />
                        <Route path='/help_support' component={HelpSupport} />
                        <Route path='/version' component={Version} />
                        <Route path='/system_account' component={SystemAccount} />
                        <Route path='/master_data' component={MasterData} />
                        <Route path='/sales_quotation' component={SalesQuotation} />
                        <Route path='/voyage' component={Voyage} />
                        <Route path='/outbound' component={Outbound} />
                        <Route path='/inbound' component={Inbound} />
                        <Route path='/bookingChanges' component={BookingChanges} />
                        <Route path='/notifications' component={Notification} />
                        <Route path='/calendar' component={Calendar} />
                        <Route path='/waiver' component={Waiver} />
                        <Route path='/CROAccounting' component={CROAccounting} />
                        <Route path='/Hustling' component={Hustling} />
                        <Route path='/customerRequest' component={CustomerRequest} />
                        <Route path='/overrideCharge' component={OverrideCharge} />
                        {/* <Route path='/SQUpdate' component={SQUpdate} /> */}
                        <Route component={Page404} />
                      </Switch>
                    </React.Fragment>
                  }
                {/* <AppUpdate /> */}
                </Layout>
              ) : 
                window.location.pathname.substring(0, 25) === "/booking/shipmentTracking" ?
                <React.Fragment>
                  <Switch>
                    <Route path='/booking/shipmentTracking/:bookingRef' render={props => <ShipmentTracking props={props} />} />
                    <Route path='/booking/shipmentTracking' render={props => <ShipmentTracking props={props} />} />
                  </Switch>
                </React.Fragment>
                :
                <React.Fragment>
                  <Layout user={this.state.user} path={window.location.pathname}>
                    <React.Fragment>
                      <Switch>
                        <Route exact path='/' component={LandingPage} />
                        <Route exact path='/signin' component={Signin} />
                        <Route exact path='/resetPassword' component={ResetPassword} />
                        <Route exact path='/account/setup/u/:userId/:token' component={AccountSetup} />
                        <Route exact path='/version' component={Version} />
                        <Route exact path='/booking/link/t/:token' component={BookingLink2} />
                        <Route exact path='/booking/AuthorizationLetter/:id' component={AuthorizationLetter} />
                        <Route exact path='/booking/PickUpRequest/:id' component={PickUpRequest} />
                        <Route exact path='/booking/success/:bookingRef' component={BookingSuccess} />
                        <Route exact path='/booking/loadingConfirmation/:bookingRef/:token' component={loadingConfirmation} />
                        <Route component={Page404} />
                      </Switch>
                    </React.Fragment>
                  </Layout>
                </React.Fragment>
            }
          </div>
        )}
    </Router>
    </ThemeProvider>)
  }
}
function mapStateToProps(state) {
  const { currentVersion, allowLeavePage, userlogin } = state.users;
  return {
      currentVersion, allowLeavePage, userlogin,
  };
}
export default connect(mapStateToProps)(App)
